<template>
  <div class="rating-container">
    <div v-if="title" class="csat-title">{{ title }}</div>
    <star-rating
      :selected-rating="selectedRating"
      @starClick="setRating"
    ></star-rating>
    <div class="rating-tooltip">
      <div class="rating-tooltip-title">{{ ratingTooltipTitle }}</div>
      <div class="rating-tooltip-subtitle" v-if="ratingTooltipSubtitle">
        {{ ratingTooltipSubtitle }}
      </div>
    </div>
  </div>
</template>
<script>
import Utility from "../../helpers/utility";
import { keyMapsMutation } from "../../helpers/storeKeys";
import StarRating from "./StarRating.vue";

export default {
  name: "CsatOverallRating",
  props: {},
  components: {
    StarRating,
  },
  mounted() {},
  methods: {
    setRating(star) {
      this.$store.commit(keyMapsMutation.UPDATE_SELECTED_RATING, star);
      Utility.vibrateOnClick();
    },
  },
  computed: {
    selectedRating() {
      return this.$store.state.CsatFeedback.selectedRating;
    },
    title() {
      return this.selectedRatingData?.title || "";
    },
    ratingTooltipTitle() {
      return this.selectedRatingData?.text || this.overallData?.subTitle;
    },
    ratingTooltipSubtitle() {
      return this.selectedRating > 0 && this.selectedRatingData?.subText;
    },
    overallData() {
      return this.$store.state.CsatFeedback.csatTemplateData?.overall;
    },
    overallDataRatings() {
      return this.overallData?.ratings;
    },
    selectedRatingData() {
      return this.overallDataRatings?.[this.selectedRating];
    },
  },
};
</script>
